import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Navbar />

    <div
      style={{
        display: 'flex', flex: 1,
        marginTop: 'var(--nav-height)',
        minHeight: 'calc(100vh - var(--nav-height))',
      }}
    >
      <Sidebar />

      <main
        style={{
          marginLeft: 260,
          flex: 1,
          padding: 'clamp(16px, 4vw, 32px)',
          minWidth: 0,
          animation: 'fadeIn 0.3s ease',
        }}
        className="main-content-el"
      >
        {children}
      </main>
    </div>

    <Footer />

    <style>{`
      @media (max-width: 900px) {
        .main-content-el { margin-left: 0 !important; }
      }
    `}</style>
  </div>
);

export default Layout;
